export default __webpack_public_path__ + "static/media/comming-soon.9077f26a.svg";